import { LeaveAllowancePeriod } from '../gql/graphql.generated';
import { TextColors } from '../tasks/task.types';
import { strings } from '../translation/strings';

export const ALLOWANCE_PERIOD_LABELS: Record<LeaveAllowancePeriod, string> = {
  [LeaveAllowancePeriod.PerYear]: 'Per Year',
  [LeaveAllowancePeriod.PerMonth]: 'Per Month'
};

export const getAllowancePeriodLabel = (period?: LeaveAllowancePeriod): string =>
  period ? ALLOWANCE_PERIOD_LABELS[period] : '';

export const ALLOWANCE_PERIOD_OPTIONS = Object.values(LeaveAllowancePeriod).map(value => ({
  value,
  label: ALLOWANCE_PERIOD_LABELS[value]
}));

export enum LeaveMeasurementUnit {
  DAYS = 'days',
  HOURS = 'hours'
}

export const useLeaveMeasurementUnitOptions = () => {
  return [
    { value: LeaveMeasurementUnit.DAYS, name: strings.settings.manageLeave.units.days }
    //{ value: LeaveMeasurementUnit.HOURS, name: strings.settings.manageLeave.units.hours }
  ];
};

export enum LeaveLimitPeriod {
  ROSTER = 'rosterPeriod',
  DAY = 'day',
  WEEK = 'week',
  YEAR = 'year'
}

export const useLeavePeriodOptions = () => {
  return [
    { value: LeaveLimitPeriod.ROSTER, name: strings.settings.manageLeave.period?.rosterPeriod }
    //{ value: LeaveLimitPeriod.YEAR, name: strings.settings.manageLeave.period?.year }
  ];
};

export interface LeaveLimit {
  value: number;
  mandatory: boolean;
  period: LeaveLimitPeriod;
}

export interface LeaveLimitSettings {
  max: LeaveLimit;
  min: LeaveLimit;
  unit: LeaveMeasurementUnit;
  consecutiveMax: number;
  consecutiveOverride: boolean;
}

export const defaultLimitSettings: LeaveLimitSettings = {
  unit: LeaveMeasurementUnit.DAYS,
  min: { value: 0, period: LeaveLimitPeriod.ROSTER, mandatory: false },
  max: { value: 0, period: LeaveLimitPeriod.ROSTER, mandatory: false },
  consecutiveMax: 0,
  consecutiveOverride: false
};

export interface LeaveProperties {
  displayName: string;
  systemCode: string;
  systemCode2: string;
  color: string;
  textColor?: TextColors;
  tapNumber: number;
  managerOnly: boolean;
}

export const defaultProperties: LeaveProperties = {
  displayName: '',
  systemCode: '',
  systemCode2: '',
  color: '',
  textColor: TextColors.BLACK,
  tapNumber: -1,
  managerOnly: false
};

export interface LeaveType {
  id: string;
  name: string;
  active: boolean;
  properties: LeaveProperties;
  limitSettings?: LeaveLimitSettings;
  allowanceAmount?: number;
  allowancePeriod?: LeaveAllowancePeriod;
}
